module.exports = __webpack_public_path__ + "static/media/pic3.96347ede.jpg";